import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, ProjectExpense } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeProjectExpense(
    request: Boundaries["removeProjectExpense"]["request"],
  ): void;
}

function useRemoveProjectExpense(
  projectExpense: Identifiable<ProjectExpense>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveProjectExpenseRequestPending(projectExpense),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveProjectExpenseRequestSuccess(projectExpense),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveProjectExpenseRequestFailure(projectExpense),
    ),
    removeProjectExpense: core.removeProjectExpense,
  };
}

export { useRemoveProjectExpense };
